<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms" ref="isnowcom"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      rowObj: {}, // 跳转数据
    };
  },
  components: {
    videoDataPage: () => import("./videoDataPage.vue"),
    getVideoUrl: () => import("./getVideoUrl.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "videoDataPage";
        case 1:
          return "getVideoUrl";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      this.isActive = index;
    },
  },
  updated() {
    {
      window.scroll(0, 0);
    }
  },
};
</script>
